import { jsx as _jsx } from "react/jsx-runtime";

function SvgLocation() {
  return _jsx("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    children: _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5 10.182C5 6.194 8.155 3 12 3s7 3.194 7 7.182c0 2.788-1.775 5.501-3.734 7.616A26.288 26.288 0 0112 20.76a26.283 26.283 0 01-3.266-2.963C6.775 15.683 5 12.97 5 10.182zm6.422 12.634l-.016-.01-.074-.053a25.464 25.464 0 01-1.214-.93 28.272 28.272 0 01-2.852-2.666C5.225 16.953 3 13.757 3 10.182 3 5.132 7.008 1 12 1s9 4.132 9 9.182c0 3.575-2.225 6.771-4.266 8.975a28.263 28.263 0 01-3.796 3.4c-.115.085-.206.151-.27.196l-.074.052-.016.011a.996.996 0 01-1.156 0zm-1.089-12.634c0-.975.768-1.727 1.667-1.727.9 0 1.667.752 1.667 1.727 0 .975-.768 1.727-1.667 1.727-.9 0-1.667-.752-1.667-1.727zM12 6.455c-2.046 0-3.667 1.69-3.667 3.727s1.62 3.727 3.667 3.727c2.046 0 3.667-1.69 3.667-3.727S14.047 6.455 12 6.455z"
    }, void 0)
  }), void 0);
}

export default SvgLocation;